<div class="res">
  @for (res of dataMeter().measurmentDatas ; track $index) {

  <div class="content">
    <img [src]="res.img" alt="IMG" />
    <div
      class="sat"
      [ngClass]="{
        B1: res.weight === 1,
        B2: res.weight === 2,
        B3: res.weight === 3,
        B4: res.weight === 4,
        'print-mode': print()
      }"
    >
      <p
        class="divider"
        [ngClass]="{
          ps1: res.weight === 1,
          ps2: res.weight === 2,
          ps3: res.weight === 3,
          ps4: res.weight === 4
        }"
      ></p>

      <p class="desc">{{ res.description }}</p>

      <p
        class="percent"
        [ngClass]="{
          ps1: res.weight === 1,
          ps2: res.weight === 2,
          ps3: res.weight === 3,
          ps4: res.weight === 4
        }"
      >
        {{ res.percentage }}%
      </p>
      <p
        class="footer"
        [ngClass]="{
          ps1: res.weight === 1,
          ps2: res.weight === 2,
          ps3: res.weight === 3,
          ps4: res.weight === 4
        }"
      ></p>
    </div>
  </div>

  }
</div>
